import { useState } from "react";
import './Styles/story.css';
import LoadingAnimation from "./LoadingAnimation";
import SearchForm from "./Header/SearchForm";
import LoadedStory from "./LoadedResponses/LoadedStory";

const Story = (props) => {
    const [userId, setUserId] = useState("");
    const [responseObj, setResponseObj] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [hasLoaded, setHasLoaded] = useState(false);
    // const [storyArray, setStoryArray] = useState([]);
    
    function submitHandler(e) {
        e.preventDefault();
        if(userId.length === 0){
            alert("Empty Username !");
            return;
        }
        setIsLoading(true);
        fetchProfile();
    }

    function onChangehandler(e) {
        setUserId(e.target.value);
    }

    const keyArray = [
        /*'60adc1bb24msh08b58709c254195p1ceaf9jsn702845084af7', // hannanmaxdev
        'a9180eee71msh7daf37d8a65155fp1135c4jsn69a08279cc3c', // 16bcah06
        '1fc1557c64mshac7f9f1ef7bd22ap1117f9jsn460218e2802e', // wishsweep
        'dc0b9e0c53mshdcc3d86bcee2f32p1294aajsn24e216d7fea9', // maxshare.dev
        '10f635b96bmsha0ca3a88fc4284cp1ae189jsn7c031834e744',*/ // i v
        'fac46d21e6msh47540c3dcf1efccp1826c6jsn02f539467773', // khadii143h done
        'c2854576a9mshb1ff9a9370c36f6p1e1e4bjsn387d5fc77dca', //DKMWHACKER done
        '911483c971mshdb95a4156dc5d7cp1bace1jsn1da8bf088b7f', // dipti done
        '066cbe2cd7msh36f61eefa10031dp1340c8jsna5da954d7c8c', // hmdevcoders  done
        'd8bad5a0fdmshc15f444f8342ecep19ee5ajsn04ce42f2b0df', // mantleboy629 // i . com
        'ccc41a5a88msh5db14c8020343d3p1e64a5jsn7843146453e7', // mantleboy.627
        '687d5d8f6fmsh2b1082c117dc180p143dd4jsnfb2291c54ecb' // Hannan.kananbardoli
    ];
    //var randomKey = Math.floor(Math.random() * keyArray.length);

    async function fetchProfile() {
        const id = userId;
        var response = await fetch(
            `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${id}&response_type=story&corsEnabled=true`,
            {
                method: "GET",
                headers: {
                    "x-rapidapi-key":
                        keyArray[0],
                    "x-rapidapi-host":
                        "instagram-bulk-profile-scrapper.p.rapidapi.com",
                },
            }
        );
        var data = await response.json();
        /*console.log("From Story: ", data);
        console.log("Key: ", keyArray[randomKey]);*/
        if(data.hasOwnProperty('message')){
            response = await fetch(
                `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${id}&response_type=story&corsEnabled=true`,
                {
                    method: "GET",
                    headers: {
                        "x-rapidapi-key":
                            keyArray[1],
                        "x-rapidapi-host":
                            "instagram-bulk-profile-scrapper.p.rapidapi.com",
                    },
                }
            );
            data = await response.json();
            /*console.log("From Story: ", data);
            console.log("Key: ", keyArray[randomKey]);*/
            if(data.hasOwnProperty('message')){
                response = await fetch(
                    `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${id}&response_type=story&corsEnabled=true`,
                    {
                        method: "GET",
                        headers: {
                            "x-rapidapi-key":
                                keyArray[2],
                            "x-rapidapi-host":
                                "instagram-bulk-profile-scrapper.p.rapidapi.com",
                        },
                    }
                );
                data = await response.json();
                /*console.log("From Story: ", data);
                console.log("Key: ", keyArray[randomKey]);*/
                if(data.hasOwnProperty('message')){
                    response = await fetch(
                        `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${id}&response_type=story&corsEnabled=true`,
                        {
                            method: "GET",
                            headers: {
                                "x-rapidapi-key":
                                    keyArray[3],
                                "x-rapidapi-host":
                                    "instagram-bulk-profile-scrapper.p.rapidapi.com",
                            },
                        }
                    );
                    data = await response.json();
                    /*console.log("From Story: ", data);
                    console.log("Key: ", keyArray[randomKey]);*/
                    if(data.hasOwnProperty('message')){
                        response = await fetch(
                            `https://instagram-bulk-profile-scrapper.p.rapidapi.com/clients/api/ig/ig_profile?ig=${id}&response_type=story&corsEnabled=true`,
                            {
                                method: "GET",
                                headers: {
                                    "x-rapidapi-key":
                                        keyArray[4],
                                    "x-rapidapi-host":
                                        "instagram-bulk-profile-scrapper.p.rapidapi.com",
                                },
                            }
                        );
                        data = await response.json();
                        /*console.log("From Story: ", data);
                        console.log("Key: ", keyArray[randomKey]);*/
                        if(data.hasOwnProperty('message')){
                            if (!window.confirm('Limit Reached... The HannanMaxIG has 4000 REQUEST limit Per Day only... Please try again leter... or download android HannanMaxIG app from below link...')) {
                                window.location.href = "https://www.hannanmax.com/HannanMaxIG/story";
                            } else {
                                window.location.href = "https://www.hannanmax.com/HannanMaxIG/story";
                            }
                        } else {
                            setResponseObj(data[0]);
                            setIsLoading(false);
                            setHasLoaded(true);
                        }
                    } else {
                        setResponseObj(data[0]);
                        setIsLoading(false);
                        setHasLoaded(true);
                    }
                } else {
                    setResponseObj(data[0]);
                    setIsLoading(false);
                    setHasLoaded(true);
                }
            } else {
                setResponseObj(data[0]);
                setIsLoading(false);
                setHasLoaded(true);
            }
        } else {
            setResponseObj(data[0]);
            setIsLoading(false);
            setHasLoaded(true);
        }
    }

    return (
        <section id="story-section">
            <SearchForm submitHandler={submitHandler} onChangehandler={onChangehandler} placeholder="Enter Username"/>

            <main className="story-response">
                {isLoading && <LoadingAnimation />}
                {hasLoaded && <LoadedStory responseObj={responseObj} />}
            </main>
        </section>
    );
}

export default Story;